import React from "react";
import { BarChart3 } from "lucide-react";
import { Link, useParams } from "wouter";

const IndexAnalysisPage: React.FC = () => {
  const { clientCode } = useParams<{ clientCode: string }>();
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="bg-yellow-50 dark:bg-yellow-900/30 rounded-lg shadow p-6 mb-6">
          <div className="flex items-center gap-3 mb-2">
            <BarChart3 className="w-7 h-7 text-yellow-700" />
            <h1 className="text-2xl font-bold text-yellow-900 dark:text-yellow-100">
              Index Analysis
            </h1>
          </div>
          <div className="text-yellow-900 dark:text-yellow-200 text-sm space-y-2">
            <p>Index analysis examines the structure, usage, and effectiveness of database indexes to optimize query performance and resource utilization. Key aspects include:</p>
            <ul className="list-disc pl-6">
              <li><b>Index Coverage:</b> Ensure all critical queries are supported by appropriate indexes.</li>
              <li><b>Redundant Indexes:</b> Identify and remove duplicate or overlapping indexes.</li>
              <li><b>Unused Indexes:</b> Detect indexes that are not used by queries and consider dropping them.</li>
              <li><b>Fragmentation:</b> Analyze index fragmentation and plan for regular maintenance (rebuild/reorganize).</li>
              <li><b>Index Types:</b> Evaluate the use of clustered, non-clustered, filtered, and full-text indexes.</li>
              <li><b>Write Impact:</b> Balance index benefits for reads with their overhead on data modifications.</li>
              <li><b>Storage:</b> Monitor index size and storage consumption.</li>
            </ul>
            <p>Effective index management is essential for maintaining fast, efficient, and scalable database operations.</p>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">See Also</h2>
          <Link href={`/clients/${clientCode}/schema-analysis`} className="text-shiftleft-700 hover:underline">
            ← Back to Database Schema Analysis
          </Link>
        </div>
      </div>
    </div>
  );
};

export default IndexAnalysisPage;
